export type MethodTextProfileIdentifier = 'white_collar' | 'blue_collar' | 'azubis';

export const METHOD_TEXT_PROFILE_IDENTIFIERS: MethodTextProfileIdentifier[] = [
  'white_collar',
  'blue_collar',
  'azubis',
];

export const DEFAULT_METHOD_TEXT_PROFILE: MethodTextProfileIdentifier = 'white_collar';

export type MethodTextProfile = {
  identifier: MethodTextProfileIdentifier;
  name?: string;
};

export type MethodTextProfilesResponse = MethodTextProfile[];
